import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import {
    getTypeColors
} from "../../../../helpers/theme/typeColors";
import type {
    Mutable
} from "../../../../types";
import type {
    SidebarActionPlacement
} from "../../type";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

export const getSidebarIconButtonColors = ({
    isEmphasized,
    isActiveRow,
    isDisabled,
    colors
}: {
    colors: NCoreUIKit.ActivePalette["colors"];
    isEmphasized: boolean;
    isActiveRow: boolean;
    isDisabled: boolean;
}): {
    iconColorKey: keyof NCoreUIKit.IconContentColors;
    iconColor: string;
} => {
    if(isDisabled) {
        return {
            iconColor: getTypeColors({
                isDisabled: true,
                variant: "ghost",
                type: "neutral",
                colors
            }).iconColor,
            iconColorKey: "disabled"
        };
    }

    if(isActiveRow) {
        return {
            iconColor: colors.content.text.high,
            iconColorKey: "high"
        };
    }

    return isEmphasized ? {
        iconColor: colors.content.icon.default,
        iconColorKey: "default"
    } : {
        iconColor: colors.content.icon.mid,
        iconColorKey: "mid"
    };
};

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    surface: {
        justifyContent: "center",
        alignItems: "center"
    }
});

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    isDisabled,
    isVisible,
    placement,
    borders,
    colors,
    radius
}: {
    colors: NCoreUIKit.ActivePalette["colors"];
    shapeConfigs: NCoreUIKit.ShapeConfigs;
    placement: SidebarActionPlacement;
    borders: NCoreUIKit.Borders;
    isFocusVisible: boolean;
    isDisabled: boolean;
    isVisible: boolean;
    radius: number;
}) => {
    const styles = {
        surface: {
            height: placement.visualSize,
            width: placement.visualSize,
            ...getCornerStyle({
                shapeConfigs,
                radius
            })
        } as Mutable<ViewStyle>,
        container: {
            opacity: isVisible ? 1 : 0,
            height: placement.hitSize,
            width: placement.hitSize
        } as Mutable<ViewStyle>
    };

    if(isDisabled) {
        Object.assign(styles.container, webStyle({
            cursor: "not-allowed"
        }));
    }

    Object.assign(styles.surface, getFocusRingStyle({
        colorKey: "default",
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
